import {
  SAVE_NOTE_TEXT,
  SAVE_ATTACHMENT,
  DELETE_ATTACHMENT,
  DELETE_NOTE_DATA,
  SET_NOTE_ERROR,
  SET_NOTE_SUCCESS
} from "../constants/consultNote";

const initialState = {
  error: false,
  success: false,
  text: null,
  attachments: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_NOTE_TEXT:
      return {
        ...state,
        text: action.payload
      };
    case SAVE_ATTACHMENT:
      return {
        ...state,
        attachments: [...state.attachments, action.payload]
      };
    case DELETE_ATTACHMENT:
      return {
        ...state,
        attachments: state.attachments.filter(
          item => item.url !== action.payload.url
        )
      };
    case DELETE_NOTE_DATA:
      return {
        ...state,
        error: false,
        success: false,
        text: null,
        attachments: []
      };
    case SET_NOTE_ERROR:
      return {
        ...state,
        error: action.payload,
        success: false
      };
    case SET_NOTE_SUCCESS:
      return {
        ...state,
        success: action.payload,
        error: false
      };
    default:
      return state;
  }
}
